var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-footer"},[_c('div',{staticClass:"navigation-footer-inner"},[_c('router-link',{staticClass:"next-button",attrs:{"to":'/' + _vm.nextLink}},[_c('img',{attrs:{"src":_vm.img,"alt":"next"}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }